import {push} from 'react-router-redux';
import axios from 'axios';
import qs from 'qs';
import {setLocale} from 'react-redux-i18n';

import * as endpoints from '../common/apiEndpoints';
import {CLEAR_APPLICATION_STATE} from '../common/actionTypes';
import * as types from './actionTypes';

export function login(credentials) {
  return function(dispatch) {
    dispatch({
      type: types.CUSTOMER_LOGIN_ATTEMPT
    });

    const credentialsQuery = qs.stringify({
      'grant_type': 'password',
      'username': credentials.email,
      'password': credentials.password
    });

    return new Promise((resolve, reject) => {
      axios.post(endpoints.AUTH_TOKEN, credentialsQuery)
        .then((response) => {
          const accountInfo = {
            token: response.data.access_token,
            userName: response.data.Username,
            fullName: `${response.data.Firstname} ${response.data.Lastname}`,
            isActive: response.data.IsActive,
            isDemoUser: response.data.IsDemoUser,
            isMasterUser: response.data.IsMasterUser,
            remember: credentials.remember  
          };
          
          dispatch(loginSuccess(accountInfo));
          resolve();
        })
        .catch((error) => {
          if(error.response) {
            dispatch(loginFailed());
          } else { 
            dispatch({type: types.SHOW_ERROR_MODAL});
          }
          reject();
        });
    });
  };
}

export function logout() {
  return function(dispatch) {
    localStorage.setItem('token', '');
    dispatch({type: types.CUSTOMER_LOGOUT});
    dispatch({type: CLEAR_APPLICATION_STATE});
    dispatch(push('/'));
  };
}


//demo actions

export function showDemoModal() {

  return function(dispatch) {
    
    dispatch({type: types.SHOW_DEMO_MODAL});
  };
}

export function hideDemoModal() {
  return function(dispatch) {
    dispatch({type: types.HIDE_DEMO_MODAL});
  };
}


function loginSuccess(accountInfo) {
  return function(dispatch) {
    let rememberUserName = '';
    if(accountInfo.remember) {
      rememberUserName = accountInfo.userName;
    }
    localStorage.setItem('rememberUserName', rememberUserName);
    localStorage.setItem('token', accountInfo.token);

    dispatch({
      type: types.CUSTOMER_LOGIN_SUCCESS,
      payload: accountInfo
    });

    dispatch(getCustomerContext());
  };
}

function loginFailed() {
  return {
    type: types.CUSTOMER_LOGIN_FAIL
  };
}

function bindAxiosTokenInterceptor() {
  axios.interceptors.request.use(function(config) {
      const token = localStorage.token;
      if(token !== null) {
        config.headers.Authorization = `bearer ${token}`;
      }
      return config;
    }, function(error) {
      return Promise.reject(error);
    });
}

export function getCustomerContext() {
  return function(dispatch) {
    axios.get(endpoints.CUSTOMER_MYCONTEXT)
      .then((response) => {
        let subscriptionList = [];
        const subscriptions = response.data.Subscriptions;
        subscriptions.forEach((subscription) => {
          let pageOffset = {
            PosX: 0,
            PosY: 0
          };

          let isPaperSizeLetter = false;
          let usePLUCode  = true;
          let useUSMetrics  = false;
          let labelTitleOrder = 0;

          if(subscription.Subscription.LabelSettings.PageRenderingPositionOffset !== null)
          {
            pageOffset = subscription.Subscription.LabelSettings.PageRenderingPositionOffset;
          }

          if(subscription.Subscription.LabelSettings.IsPaperSizeLetter !== null)
          {
            isPaperSizeLetter = subscription.Subscription.LabelSettings.IsPaperSizeLetter;
          }

          if(subscription.Subscription.LabelSettings.UsePLUCode !== null)
          {
            usePLUCode = subscription.Subscription.LabelSettings.UsePLUCode;
          }

          if(subscription.Subscription.LabelSettings.UseUSMetrics !== null)
          {
            useUSMetrics = subscription.Subscription.LabelSettings.UseUSMetrics;
          }

          if(subscription.Subscription.LabelSettings.LabelTitleOrder !== null)
          {
            labelTitleOrder = subscription.Subscription.LabelSettings.LabelTitleOrder;
          }

          let sub = {
            id: subscription.Subscription.ID,
            name: subscription.Subscription.Name,
            locale: 'en-US',                                  // TODO: HACK HACK HACK: We don't need this soon, going to use browser locale
            permissions: subscription.Permissions,
            excelKey: subscription.Subscription.ArticleMappingExcelKey,
            styles: subscription.Subscription.LabelSettings.Styles,
            logos: subscription.Subscription.LabelSettings.Logos,
            pageOffset: pageOffset,
            useUSMetrics:useUSMetrics,
            usePLUCode:usePLUCode,
            isPaperSizeLetter:isPaperSizeLetter,
            labelTitleOrder:labelTitleOrder,
            language:subscription.Subscription.Channel.Language,

            manualBilling: subscription.Subscription.ManualBilling,
            supportsCareSheets: subscription.Subscription.Channel.SupportsCaresheets
          };
          subscriptionList.push(sub);
        });

        const activeSubscriptionId = (subscriptionList.length > 0) ? subscriptionList[0].id : 0;
        const contextInfo = {
          userName: response.data.Username,
          fullName: `${response.data.Firstname} ${response.data.Lastname}`,
          isActive: response.data.IsActive,
          isDemoUser: response.data.IsDemoUser,
          isMasterUser: response.data.IsMasterUser,
          subscriptionList: subscriptionList,
          activeSubscriptionId: activeSubscriptionId
        };

        //set local after login
        let lan = response.data.Subscriptions["0"].Subscription.Channel.Language;

        if(lan==='German')
          dispatch(setLocale('de-DE'));
        else
          dispatch(setLocale('en-US'));
          

        axios.get(`${endpoints.ORDER_MANAGEMENT_LINK}?subscriptionID=${contextInfo.activeSubscriptionId}`)
          .then((response) => {
            contextInfo.managementLink = response.data;

            dispatch({
              type: types.CUSTOMER_CONTEXT_RECEIVED,
              payload: contextInfo
            });
          });
      })
      .catch((error) => {
        if(error.response) {
            // The token authorization has failed and so we need to logout the user and kick them back to login.
            dispatch(logout());
          } else {
            dispatch({type: types.SHOW_ERROR_MODAL});
          }
      });
  };
}

// Attempt to use a stored token if one is available in localStorage
export function attemptTokenLogin() {
  return function(dispatch) {
    bindAxiosTokenInterceptor(); 
    const token = localStorage.token;
    if(token !== '' && token !== undefined) {
      dispatch(getCustomerContext());
      dispatch({type: types.TOKEN_LOGIN_SUCCESS});
    }
  };
}

export function setActiveSubscription(subscriptionId) {
  return function(dispatch) {
    axios.get(`${endpoints.ORDER_MANAGEMENT_LINK}?subscriptionID=${subscriptionId}`)
      .then((response) => {
        dispatch({
          type: types.SET_ACTIVE_SUBSCRIPTION,
          payload: {
            activeSubscriptionId: subscriptionId,
            managementLink: response.data 
          }
        });
      });    
  };
}

export function savePasswordChange(oldPassword, newPassword) {
  return function(dispatch) {
    return new Promise((resolve, reject) => {
      let passwordData = {
        OldPassword: oldPassword,
        NewPassword: newPassword,
        ConfirmPassword: newPassword
      };

      axios.post(endpoints.CHANGE_PASSWORD, passwordData)
      .then(() => {
        dispatch({type: types.PASSWORD_CHANGE_SUCCESS});
        resolve();
      })
      .catch(() => {
        reject();
      });
    });
  };
}

export function forgotPassword(username) {
  return function(dispatch) {
    let passwordData = {
      UsernameOrEmail: username
    };

    axios.post(endpoints.FORGOT_PASSWORD, passwordData)
      .then(() => {
        dispatch({type: types.FORGOT_PASSWORD_SENT});
      })
      .catch(() => {
        dispatch({type: types.SHOW_ERROR_MODAL});
      });
  };
}


/** WEBPACK FOOTER **
 ** ./src/modules/customer/actions.js
 **/